import React, {Fragment, useEffect, useState} from "react";
import axios from "axios";
import {Form} from "react-bootstrap";
import {accountService} from "./Account.service";

import {convertToRaw, EditorState} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
// import htmlToDraft from "html-to-draftjs";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

accountService.isLoggedRedirect();
function AddCareer() {

   const mytoken = JSON.parse(localStorage.getItem('token')).token;
   const config = {headers: { Authorization: `Bearer ${mytoken}` } };
   const [career, setCareer] = useState({});
   const [idcv, setDataIdcv] =  useState([]);

   // const html = '<p>Add a descrition <strong>Here</strong>😀</p>';
   // const contentBlock = htmlToDraft(html);
   const [editorState, setEditorState] = useState(EditorState.createEmpty());

    useEffect(() => {
            axios.get(`https://api.nvdxavier.com/api/cvids`, config)
                .then(data => {
                     setDataIdcv(data.data);
                    }
                ).catch(err => console.error(err));
    }, [config])


    // const WYSIWYGEditor = () => {
    //     const [editorState, setEditorState] = useState(EditorState.createEmpty());
    //     const onEditorStateChange = editorState => {
    //         return setEditorState(editorState)
    //     }
    // }

    const handleChange = (e) => {
        const name = e.target.name;
         const value = e.target.value;

        if(name === 'dateend' || name === 'datestart'){

            setCareer({...career, [name]: value+'T15:52:01+00:00'});
        }else{
            setCareer({...career, [name]: value});
        }

    };
    const handleSubmitNewCareer = (e) => {
        e.preventDefault();
        console.log(e.target.mycvid.value)
        if(!career.mycvid){
            career.mycvid  =  e.target.mycvid.value
        }
        if(!career.inplace){
            career.inplace  =  false
        }else{
            career.inplace  =  true
        }
        career.taskdescription = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        const dataEncodedtoJson = JSON.stringify(career);
         axios.post(`https://api.nvdxavier.com/api/career`, dataEncodedtoJson, config)
              .then(data => data.status === 201 ? handleImageFile(e, data.data.career) : console.log(data.status))
        .catch(err => console.error(err));
    }

    const handleImageFile = (e, idcareer) => {
        e.target.careerid.value = idcareer;
        axios.post(`https://api.nvdxavier.com/api/media`, e.target, config)
            .then(data => data.status === 200 ? window.location.replace("/admin/careers")  : console.log(data.status))
            .catch(err => console.error(err))
    }

    const onEditorStateChange = (state) => {
        setEditorState(state);
    };
    // const handleSave = () => {
    //     const content = editorState.getCurrentContent();
    //     const rawContent = convertToRaw(content);
    // };
    const uploadImageCallBack = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve({ data: { link: reader.result } });
            };
            reader.readAsDataURL(file);
        });
    }
        return (

            <Fragment>
                <section id="signup" className="signup-section">
                    <div className="container" key="CareerAdminadd">
                        <h4>Add a new career</h4>
                        <div className="align-self-center" key="CareerAdminAlign">
                            <Form  onSubmit={handleSubmitNewCareer}>
                                <Form.Group className="mb-3 col-4" controlId="formBasicEmail" >
                                    <Form.Label>Curriculum:</Form.Label>
                                    <Form.Select name="mycvid" onChange={handleChange} required="true">
                                        {idcv.map((item) => {
                                            return (
                                                <option value={item.id}>{item.id}</option>
                                            )
                                        })
                                        }
                                    </Form.Select>
                                    <Form.Group controlId="formFileMultiple" className="mb-3">
                                        <Form.Label>Multiple files input example</Form.Label>
                                        <Form.Control type="file" name="imageFile[]" multiple onChange={handleChange} />
                                    </Form.Group>
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control type="text" name="jobtitle" onChange={handleChange} required="true"/>

                                    <Form.Control type="text" name="imagetype" value="career" hidden="true"/>
                                    <Form.Control type="text" name="careerid" hidden="true"/>

                                <Form.Label>Date start  :</Form.Label>
                                <Form.Control size="sm" type="date"  name="datestart" onChange={handleChange} required="true"/>
                                <Form.Label>Date end  : </Form.Label>
                                <Form.Control size="sm" type="date" name="dateend" onChange={handleChange} required="true"/>
                                <Form.Label>Task description</Form.Label>
                                <Form.Control size="sm" as="textarea" name="taskdescription" hidden="true"/>
                                    <Editor
                                        name="editor_content"
                                        editorState={editorState}
                                        onEditorStateChange={onEditorStateChange}
                                        toolbar={{
                                            image: { uploadCallback: uploadImageCallBack, previewImage: true },
                                            blockType: {
                                                options: ['Normal', 'H1', 'H2', 'H3'],
                                            },
                                        }}
                                    />
                                <Form.Label>Society</Form.Label>
                                <Form.Control type="text" name="society" onChange={handleChange} required="true"/>
                                <Form.Label>Society address</Form.Label>
                                <Form.Control type="text" name="societyaddress" onChange={handleChange} required="true"/>
                                <Form.Label>Society website</Form.Label>
                                <Form.Control type="link" name="link" onChange={handleChange} required="true"/>
                                <Form.Label>My actual job ?</Form.Label>
                                    <Form.Check type="checkbox" name="inplace" onChange={handleChange} />
                                <input type="submit" id="onSubmitNewCareer" className="btn btn-danger"/>
                            </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="bg-danger">
                    </div>
                </section>
            </Fragment>
        );
}
 export default AddCareer;